<template>
  <WarrantsDataTableTab
    :headers="headers"
    error-title="Failed to load whitelist"
    data-testid="warrants-whitelist"
    searchable
    search-placeholder="Search account number"
    :fetcher="fetchWhitelist"
    :items-from="itemsFrom"
  />
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import WarrantsDataTableTab from "@/views/admin/warrants/components/WarrantsDataTableTab.vue"
  import { SoDataTableOptions } from "@/components/dataTable/SoDataTableServer.vue"
  import { SoDataTableHeader } from "@/types/components/SoDataTable"
  import {
    accountNumberColumn,
    createdAtColumn,
    deletedColumn,
    idColumn,
  } from "@/views/admin/warrants/warrantsColumns"
  import {
    WarrantsAccountWhitelistListResult,
    WarrantsAccountWhitelistService,
  } from "@/services/admin/WarrantsAccountWhitelistService"

  const headers: SoDataTableHeader[] = [
    idColumn,
    accountNumberColumn,
    createdAtColumn,
    deletedColumn,
  ]

  export default defineComponent({
    components: {
      WarrantsDataTableTab,
    },
    data() {
      return {
        headers,
      }
    },
    methods: {
      fetchWhitelist({ search, page, pageSize, orderBy }: SoDataTableOptions) {
        return WarrantsAccountWhitelistService.getWhitelist(
          search,
          page,
          pageSize,
          orderBy,
        )
      },
      itemsFrom(result: WarrantsAccountWhitelistListResult) {
        return result.whitelist
      },
    },
  })
</script>
